import React from "react";
import { Box, Typography } from "@mui/material";

interface SummarySectionHeaderProps {
  title: string | React.ReactNode;
  sx?: object;
}

const SummarySectionHeader: React.FC<SummarySectionHeaderProps> = ({
  title,
  sx = {},
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        px: 2,
        py: 1,
        display: "flex",
        alignItems: "center",
        borderLeft: "3px solid #00b3b5",
        borderRadius: "8px",
        backgroundColor: "#eaf7f9",
        ...sx,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{ fontSize: "14px", fontWeight: 600, color: "#6f6b7d" }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default SummarySectionHeader;
